import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex flex-wrap gap-y-4 px-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      class: "px-4",
      label: "Aturan Komisi"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Acuan Komisi",
        class: "w-6/12",
        value: _ctx.commissionTierBase
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Harga Acuan Tier",
        class: "w-6/12",
        value: _ctx.commissionPriceTierReference
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Tipe Komisi",
        class: "w-6/12",
        value: _ctx.commissionType
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Harga Acuan Komisi",
        class: "w-6/12",
        value: _ctx.commissionPriceReference
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Parameter Perhitungan",
        class: "w-full",
        value: _ctx.commissionQuantifier
      }, null, 8, ["value"])
    ]),
    _hoisted_3
  ]))
}